import { render } from "./ApplicationLogo.vue?vue&type=template&id=1eca7e78"
const script = {}

import exportComponent from "/var/www/dmp/releases/1776447385/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__